import { SET_TAIL_TYPE } from './types';
import { CHART_TAIL_TYPES } from './enums';

const initialState = { tailType: CHART_TAIL_TYPES.LEFT };

const ranges = (state = initialState, action) => {
  switch (action.type) {
    case SET_TAIL_TYPE:
      return { tailType: action.tailType };
    default:
      return state;
  }
};

export default ranges;
